import { render, staticRenderFns } from "./PrioritySelect.vue?vue&type=template&id=c10ea7f8&scoped=true"
import script from "./PrioritySelect.vue?vue&type=script&lang=js"
export * from "./PrioritySelect.vue?vue&type=script&lang=js"
import style0 from "./PrioritySelect.vue?vue&type=style&index=0&id=c10ea7f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10ea7f8",
  null
  
)

export default component.exports